<template>
  <div class="container-fluid px-0 py-4">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="row no-gutters">
          <div class="col pb-2">
            <nav aria-label="...">
              <ul class="pagination text-smallest mb-0 pb-0">
                <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                  <button class="page-link" @click="setData(1)">First</button>
                </li>

                <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                  <button class="page-link" @click="setData(page)">{{ page }}</button>
                </li>

                <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                  <button class="page-link" @click="setData(pagination.lastPage)">Last</button>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-md-auto">
            <label class="col-form-label pr-2 font-weight-bold">Filter By: </label>
          </div>
          <div class="col-md-auto px-1">
            <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="params.fleet_id">
              <!--                <option :value="null">—— SELECT PORT ——</option>-->
              <option :value="null">-- ALL FLEET --</option>
              <template v-for="fleet in fleetKeys">
                <option :value="fleet.id" v-if="fleet?.name !== 'N/A' && fleet.code !== 'N/A'">
                  {{fleet.name ? fleet.name.toUpperCase() : ''}}
                </option>
              </template>
            </select>
          </div>
          <div class="col-3 pb-2">
            <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.search" placeholder="Search Vessel">
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link btn-sm text-uppercase font-weight-bold active" id="deficiency-tab" data-toggle="tab" data-target="#deficiency" type="button" role="tab" aria-controls="deficiency" aria-selected="true" @click="getActiveTab('deficiency')">Number of Deficiency</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link btn-sm text-uppercase font-weight-bold" id="inspection-tab" data-toggle="tab" data-target="#inspection" type="button" role="tab" aria-controls="inspection" aria-selected="false" @click="getActiveTab('inspection')">Number of Inspection</button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link btn-sm text-uppercase font-weight-bold" id="detention-tab" data-toggle="tab" data-target="#detention" type="button" role="tab" aria-controls="detention" aria-selected="false" @click="getActiveTab('detention')">Detention</button>
            </li>
          </ul>
          <template v-if="loading">
            <app-loading></app-loading>
          </template>
          <template v-else>
              <div class="row pt-2">
                <div class="col-12">
                <!--DEFICIENCY TAB-->
                  <div class="table-responsive" v-if="activeTab === 'deficiency'">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th class="text-uppercase font-weight-bold text-center align-middle deficiency-headers dark-bottom-side-border" style="max-width: 150px !important;">Vessel Name</th>
                        <template v-for="(data, index) in vesselPscInspectionDeficiencies[0]?.psc">
                          <th class="text-uppercase font-weight-bold text-center align-middle dark-bottom-side-border deficiency-headers">{{data.year}}</th>
                        </template>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(data, index) in vesselPscInspectionDeficiencies" :key="index">
                        <td class="text-uppercase font-weight-bold text-center align-middle normal-headers dark-right-side-border" style="max-width: 90px !important;">{{ data.name }}</td>
                        <template v-for="(item, index) in data.psc">
                          <td class="text-center font-weight-bold align-middle text-primary" v-if="item.psc_deficiency_total_count != 0" @click="showDeficiencyModal(item, data.name)" style="cursor: pointer;">{{item.psc_deficiency_total_count}}</td>
                          <td class="text-center font-weight-bold align-middle" v-else>{{item.psc_deficiency_total_count}}</td>
                        </template>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                <!--END DEFICIENCY TAB-->
                <!--INPECTION TAB-->
                  <div class="table-responsive" v-else-if="activeTab === 'inspection'" style="max-height: 60vh;">
                      <table class="table table-bordered mr-2 table-inspection">
                        <thead>
                        <tr>
                          <th class="text-uppercase font-weight-bold text-center align-middle inspection-headers dark-bottom-side-border" style="max-width: 200px !important;" rowspan="3">Vessel Name</th>
                          <th v-for="(data, index) in vesselPscInspectionInspections[0]?.psc" class="text-uppercase font-weight-bold text-center align-middle inspection-headers dark-bottom-side-border" colspan="2">{{data.year}}</th>
                        </tr>
                        <tr>
                          <template v-for="(data, index) in vesselPscInspectionInspections[0]?.psc">
                            <th class="text-center align-middle text-uppercase inspection-headers">Nbr Inspection</th>
                            <th class="text-center align-middle text-uppercase deficiency-ins-headers">Deficiency Inspection</th>
                          </template>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(data, index) in vesselPscInspectionInspections" :key="index">
                          <td class="text-uppercase font-weight-bold text-right align-middle normal-headers dark-right-side-border" style="min-width: 170px !important;">{{ data.name }}</td>
                          <template v-for="(item, indexPsc) in data.psc">
                            <td class="text-center font-weight-bold align-middle text-primary h5" style="cursor:pointer;" v-if="item.psc.nbr_without_deficiency.length !== 0" @click="showInspectionModal('nbrInspection',item.psc.nbr_without_deficiency,data.name,item.year)">
                              {{item.psc.nbr_without_deficiency.length}}
                            </td>
                            <td class="text-center font-weight-bold align-middle" v-else>
                              {{item.psc.nbr_without_deficiency.length}}
                            </td>
                            <td class="text-center align-middle" style="cursor:pointer;" v-if="item.psc.nbr_with_deficiency.length !== 0" @click="showInspectionModal('defInspection',item.psc.nbr_with_deficiency,data.name,item.year)">
                              <span class="h5 font-weight-bold" :style="{ color: item.psc.nbr_with_deficiency.some(nbr => nbr.psc_deficiencies.some(def => def.action_code?.code === '30')) ? 'red' : '#007bff' }">
                                  {{ item.psc.nbr_with_deficiency.length }}
                              </span>
                            </td>
                            <td class="text-center font-weight-bold align-middle" v-else>{{item.psc.nbr_with_deficiency.length}}</td>
                          </template>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                <!--END INSPECTION TAB-->
                <!--DETENTION TAB-->
                  <div v-else-if="activeTab === 'detention'">
                    <template v-if="loading">
                      Loading
                    </template>
                    <template v-else>
                      <ShipsPiPSCDetention :hide-other-contents="true" :reports-detained='reports' :new-params="params"></ShipsPiPSCDetention>
                    </template>
                  </div>
                </div>
              </div>
            <!--DEFICIENCY MODAL-->
            <div class="modal fade" id="deficiencyModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title my-auto font-weight-bold text-uppercase" id="exampleModalLabel">{{ deficiencySelectedTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-12">
                        <table class="table table-bordered w-100">
                          <thead>
                          <tr>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Deficiency Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Deficiency Description</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Title</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-for="(data, index) in deficiencyMain">
                            <tr v-for="(item, indexDef) in data.psc_deficiency" :key="indexDef">
                              <td class="align-middle text-center">{{item.number_key}}</td>
                              <td class="align-middle text-center">{{item.code.code}}</td>
                              <td class="align-middle text-center">{{item.description}}</td>
                              <template v-if="indexDef === 0">
                                <td class="align-middle text-center" :rowspan="data.psc_deficiency.length">{{data.code}}</td>
                                <td class="align-middle text-center" :rowspan="data.psc_deficiency.length">{{data.title}}</td>
                                <td class="align-middle text-center" :rowspan="data.psc_deficiency.length">{{data.inspection_date}}</td>
                              </template>
                              <td class="align-middle text-center">{{item.action_code.code}}</td>
                              <td class="align-middle text-center">
                                <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToPscInspection(data.psc_id)">
                                  <font-awesome-icon icon="eye"  />
                                  View
                                </button>
                              </td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END DEFICIENCY MODAL  -->
            <!--INSPECTION MODAL-->
            <div class="modal fade" id="inspectionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title my-auto font-weight-bold text-uppercase" id="exampleModalLabel">{{ this.inspectionSelectedTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-12">
                        <table class="table table-bordered w-100">
                          <thead>
                          <tr v-if="this.inspectionSelectedModal === 'nbrInspection'">
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Report Title</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                          </tr>
                          <tr v-else>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Title</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Deficiency Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Deficiency Description</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action Code</th>
                            <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-if="this.inspectionSelectedModal === 'nbrInspection'">
                            <tr v-for="(data, index) in inspections">
                              <td class="align-middle text-center">{{index+1}}</td>
                              <td class="align-middle text-center">{{data.code}}</td>
                              <td class="align-middle text-center">{{data.title}}</td>
                              <td class="align-middle text-center">{{data.inspection_date}}</td>
                              <td class="align-middle text-center">
                                <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToPscInspection(data.id)">
                                  <font-awesome-icon icon="eye"  />
                                  View
                                </button>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <template v-for="(data, index) in inspections">
                              <tr v-for="(item, indexDef) in data.psc_deficiencies">
                                <template v-if="indexDef === 0">
                                  <td class="align-middle text-center no-rows" :rowspan="data.psc_deficiencies.length">{{index+1}}</td>
                                  <td class="align-middle text-center" :rowspan="data.psc_deficiencies.length">{{data.code}}</td>
                                  <td class="align-middle text-center" :rowspan="data.psc_deficiencies.length">{{data.title}}</td>
                                </template>
                                <td class="align-middle text-center">{{item.code.code}}</td>
                                <td class="align-middle text-center">{{item.description}}</td>
                                <template v-if="indexDef === 0">
                                  <td class="align-middle text-center" :rowspan="data.psc_deficiencies.length">{{data.inspection_date}}</td>
                                </template>
                                <td class="align-middle text-center">{{item.action_code?.code}}</td>
                                <td class="align-middle text-center">
                                  <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToPscInspection(data.id)">
                                    <font-awesome-icon icon="eye"  />
                                    View
                                  </button>
                                </td>
                              </tr>
                            </template>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END INSPECTION MODAL  -->
          </template>
        </div>
      </div>


    <router-view :key="$route.params.feature"></router-view>
  </div>
</template>

<style scoped>
.table-inspection td:nth-child(1),
.table-inspection th
{
  position: sticky;
  left: 0;
  z-index: 5;
}
.table-inspection th{
  z-index: 10;
}
.table-inspection tr:nth-child(1) th:nth-child(1){
  z-index: 99;
}
.table-inspection tr:nth-child(1) th,
.table-inspection td:nth-child(1)
{
  outline-offset: -1px ;
}
.table-inspection tr:nth-child(1) th {  outline: 3px solid #b3b3b3 ; }
.table-inspection td:nth-child(1) { outline: 2px solid #b3b3b3 ; }
.table-inspection tr:nth-child(1) th {  top:0; }
.table-inspection tr:nth-child(2) th{ top:43px; }
.nav-tabs .nav-link.active{
  color: #d3313c !important;
}
.deficiency-headers{
  background-color: #61973D;
  color: #f2f2f2;
}
.inspection-headers{
  background-color: #2E75B5;
  color: #f2f2f2;
}
.deficiency-ins-headers{
  background-color: #C55911;
  color: #f2f2f2;
}
.normal-headers{
  background-color: #e1e1e1;
  border: 1px solid #c3c3c3;
}
.dark-left-side-border{
  border-left: 3px solid #b3b3b3;
}
.dark-right-side-border{
  border-right: 3px solid #b3b3b3;
}
.dark-bottom-side-border{
  border-bottom: 3px solid #b3b3b3;
}
.dark-top-side-border{
  border-top: 3px solid #b3b3b3;
}

#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 2rem;
    color: #435464;
    height: 100%;
    text-align: center;
  }

  li:hover a {
    border-bottom: 4px solid #d3313c;
    color: #d3313c;
  }

  .nav-link span {
    font-size: 16px;
  }
}

.router-link-active {
  border-bottom: 4px solid #d3313c;
  color: #d3313c;
  font-weight: bold;

  * {
    color: #d3313c;
  }
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from 'axios';
import AppLoading from "@/components/elements/AppLoading.vue";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import loading from "@/components/elements/AppLoading.vue";
import PscIndex from "@/components/modules/psc/PscIndex.vue";
import ShipsPiAccidentIncident from "@/components/ships-pi/ShipsPiWorkingEnvironment.vue";
import ShipsPiPSCDetention from "@/components/ships-pi/psc/ShipsPiPSCDetention.vue";
export default {
  name: 'ShipsPI',
  mixins: [PaginationMixin],
  data(){
    return {
      deficiencies: [],
      deficiencyMain: [],
      deficiencySelectedTitle: null,
      loading : true,
      params : {
        fleet_id: null,
        detention_status: true,
      },
      globalIndex: 1,
      recGlobalIndex: null,
      activeTab: 'deficiency',
      inspections: [],
      inspectionSelectedModal: null,
      inspectionSelectedTitle: null,
    }
  },
  components: {
    ShipsPiPSCDetention,
    ShipsPiAccidentIncident,
    PscIndex,
    loading,
    AppLoading,
  },
  mounted: function() {
    this.globalIndex = 1;
  },
  methods : {
    ...mapActions([
      'getVesselsPscDeficiencies',
      'getVesselsPscInspections',
      'getPscReports'
    ]),

    async setData(page = 1) {
      this.loading = true;
      this.params.page = page;
      await this.getVesselsPscDeficiencies(this.params)
      await this.getVesselsPscInspections(this.params);
      await this.getPscReports(this.params);
      console.log(this.reports);
      if(this.activeTab === 'inspection'){
        $('#inspection-tab').click();
      }
      else if(this.activeTab === 'deficiency'){
        $('#deficiency-tab').click();
      }
      else if(this.activeTab === 'detention'){
        $('#detention-tab').click();
      }
      this.loading = false;
    },

    async getActiveTab(data){
      var page = 1;
      this.params.search = '';
      this.setData(page);
      this.activeTab = data;
    },

    showDeficiencyModal(data, title) {
      let counter = 0;
      this.deficiencyMain = data.psc_mains;
      this.deficiencySelectedTitle = title+" ("+data.year+")";
      $('#deficiencyModal').modal('show');

      this.deficiencyMain.forEach(main => {
        main.psc_deficiency.forEach(deficiency => {
          deficiency.number_key = ++counter;
        })
      })
    },

    showInspectionModal(type, data, title, year) {
      this.inspections = data;
      this.inspectionSelectedModal = type;
      this.inspectionSelectedTitle = title+"("+year+")";
      $('#inspectionModal').modal('show');
    },

    async goToPscInspection (reportId) {
      const route= this.$router.resolve(
        {
          name: 'PscMain',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },

    // goToPscInspection(data){
    //   window.open('/psc/'+data+'/general','_blank');
    // },

    getGlobalIndex(data) {
      if(data === 1){
        this.globalIndex = data+1;
      }
      else{
        this.globalIndex++;
      }
      return this.globalIndex;
    },
  },
  computed: {
    ...mapGetters([
      'vesselPscInspectionDeficiencies',
      'vesselPscInspectionInspections',
      'pagination',
      'fleetKeys',
      'reports'
    ]),
  },

  watch: {
    'params.search'() {
      this.setVesselsData()
    },
    'params.fleet_id'() {
      this.setData()
    },
  },

  async created() {
    this.setVesselsData = _.debounce(this.setData, 750)
    await this.setData();
  },
}
</script>
